import React, { useEffect } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Outlet,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import { SiteInfoProvider } from "./contexts/SiteInfoContext";

// Layout
import Navbar from "./components/layout/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import LandingPage from "./components/home/LandingPage";
import JobSeekerPage from "./components/home/JobSeekerPage";
import {
  ResetPasswordPage,
  LoginPage,
  ForgotPasswordPage,
  ChangePasswordPage,
} from "./components/auth";
import AdminDashboard from "./components/admin/AdminDashboard";
import NotFoundPage from "./components/NotFoundPage";
import PrivacyPolicyPage from "./components/home/PrivacyPolicyPage";
import ContentPage from "./components/home/ContentPage";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppLayout() {
  const location = useLocation();
  const hideNavbar = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {!hideNavbar && <Navbar />}
      <Outlet />
    </>
  );
}

// Data router (required for useBlocker navigation guards in CrudManager)
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppLayout />}>
      <Route path="/" element={<LandingPage />} />
      <Route path="/apply" element={<JobSeekerPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      {/* Reset Password Route */}
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <ChangePasswordPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route
        path="/terms-of-service"
        element={<ContentPage slug="terms-of-service" category="Legal" />}
      />
      <Route
        path="/cookie-policy"
        element={<ContentPage slug="cookie-policy" category="Legal" />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Route>,
  ),
);

function App() {
  return (
    <LanguageProvider>
      <SiteInfoProvider>
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors closeButton />
      </SiteInfoProvider>
    </LanguageProvider>
  );
}

export default App;
